import { 
    FETCH_LOTS,
    FETCH_LOTS_SUCCESS,
    FETCH_LOTS_FAILED,
  } from "../actions/types";
  
  export const INITIAL_STATE = {
    lots:null,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_LOTS:
        return {
          ...state,
          loading:true
        };
      case FETCH_LOTS_SUCCESS:
        return {
          ...state,
          lots:action.payload,
          loading:false
        };
      case FETCH_LOTS_FAILED:
        return {
          ...state,
          lots:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      default:
        return state;
    }
  };